import React, { Component } from "react";
import { Col, Row, Container } from "react-bootstrap";
import OfficeAddress from "../../Components/OfficeAddress/OfficeAddress";
import Footer from "../../Components/Footer/Footer";
import Map from "../../Components/Map/Map";
import "./Contact.css";
import Breadcrumbs  from 'react-router-dynamic-breadcrumbs';   
import {
  Link  as Router,
} from 'react-router-dom'
   
class Contact extends Component {
  state = {
    routes : {
      '/': 'Home',
      '/contact' : 'Contact',
    },
    address: [
      {
        key: "1",
        city: "Ambala",
        info: [
          "Bazar Radha Kishan",
          "Ambala City",
          "Haryana, India - 134002",
          "Ph. +91 171 2519448",
          "F. +91 171 22518819",
          "Email: ambala@vkpublications.com"
        ]
      },

      {
        key: "2",
        city: "Ahmedabad",
        info: [
          "D-32,GROUND FLOOR,SUMELCOMPLEX,",
          "SAFAL- -6, DUDHESHWAR CROSS ROAD",
          "OPP-HANUMANPURA,B.R.T.S",
          "BUS STOP DUDHESHWAR",
          "Ahmedabad, Gujrat, India - 380 004",
          "Ph. +91 09978918162",
          "Email: mail@vkpublications.com"
        ]
      },
      {
        key: "3",
        city: "Bengaluru",
        info: [
          "383, Ground Floor, 65th Cross",
          "5th Block, Rajaji Nagar",
          "Bengaluru, Karnataka (India)",
          " Ph. +91 80 23145345,",
          "Mob. +091 9986167032",
          "Email: bangalore@vkpublications.com"
        ]
      },
      {
        key: "4",
        city: "Bhopal",
        info: [
          "E/188, AYODHYA EXTENSION ",
          "NEAR DEVMATA HOSPITAL",
          "BY PASS ROAD,",
          " BHOPAL (MADHYA PRADESH)-462041",
          "Mob. +091 9826710383",
          "Email: mail@vkpublications.com"
        ]
      },
      {
        key: "5",
        city: "Chennai",
        info: [
          "43/1,NORTH MADA STREET",
          "  PILLAYAR KOIL STREET,KOYAMBEDU",
          "  Chennai, Tamil Nadu - 600107 (India)",
          "  Ph. +91 9902170306",
          "   Email: chennai@vkpublications.com"
        ]
      },
      {
        key: "6",
        city: "Guwahati",
        info: [
          "C/O MR. KR BORDOLAI",
          "10/BN DAS LANE,AMBARI",
          " GUWAHATI (ASSAM)-781001",
          " Ph. +91 0361 2511010",
          "  Email: mail@vkpublications.com"
        ]
      },
      {
        key: "7",
        city: "Jaipur",
        info: [
          " 83,MARUDHAR NAGAR, ",
          "DCM POST OFFICE",
          "HIRA PURA AJMER ROAD, ",
          " Jaipur, Rajasthan - 302021 (India)",
          "  Ph. +8233303007",
          " Email: jaipur@vkpublications.com"
        ]
      },
      {
        key: "8",
        city: "Kolkata",
        info: [
          " HOUSE NO-26/539-1,KORAPPATH LANE",
          "Thrissur, Kerala - 680020 (India)",
          "Ph. +91 9995399022",
          " Email: kerala@vkpublications.com"
        ]
      },
      {
        key: "9",
        city: "Kerala",
        info: [
          "HOUSE NO-26/539-1,KORAPPATH LANE",
          "Thrissur, Kerala - 680020 (India)",
          "Ph. +91 9995399022",
          "Email: kerala@vkpublications.com"
        ]
      },
      {
        key: "10",
        city: "Orissa",
        info: [
          " SANTA SAHI (NEW COLONY) ",
          "OPP. ELECTRIC SUB STATION, ",
          " BRITISH RADIO LANE,",
          "CUTTACK (ODISHA)-753001",
          " Ph. +91 9437142661",
          "Email: mail@vkpublications.com"
        ]
      },
      {
        key: "11",
        city: "Patna",
        info: [
          " HOUSE NO-30 (GROUND FLOOR)",
          "KITAB BHAWAN LANE,NORTH SK PURI",
          "  BORING ROAD Patna-800013, ",
          "Bihar (India)",
          " Ph. +91 0612-2577611",
          " Email: patna@vkpublications.com"
        ]
      },
      {
        key: "12",
        city: "Ranchi",
        info: [
          " LS/21, Harmu Housing Colony",
          " Near High Court Colony, Harmu",
          "Ranchi, Jharkhand (India) - 834002",
          "Ph. +91 9835540064",
          "Email: ranchi@vkpublications.com"
        ]
      }
    ]
  };
  render() {
  document.title = "VK Global Publications | Contact Us - we can be reached easily"

    return (
      <div>
        <div className="section1">
          <Container >
          <h3  className="  cataloguebreadcrumbs float-right">
             <Router>
               <Breadcrumbs  mappedRoutes={this.state.routes} />
             </Router>
           </h3>
          <h3 className="contact-us">Contact Us</h3>

          <div className="box1">
              <Row className="rectangleAlignment">
                <Col sm={6}>
                  <div className="Rectangle">
                    <Map zoom = {16} lat= "28.441405"  lng = "77.311532" />
                  </div>
                  <div className="detail first-detail">
                    <h6>Corporate Office</h6>
                    <p>VK Global Publications Pvt. Ltd.</p>
                    <p>15/1, Main Mathura Road, Near Sector 31</p>
                    <p>Faridabad, Haryana, India - 121003</p>
                    <p>Ph: +91 129 7117719</p>
                    <p>F: +91 129 2250322</p>
                    <span> Email :<a style = {{fontSize:'14px'}} href="mailto:mail@vkpublications.com">
                      mail@vkpublications.com
                    </a></span>
                  </div>
                </Col>
                <Col sm={6}>
                  <div className="Rectangle">
                    <Map zoom ={19} lat= "28.643693"  lng = "77.244895" />
                  </div>
                  <div className="detail first-detail">
                    <h6>Head Office</h6>
                    <p>VK Global Publications Pvt. Ltd.</p>
                    <p>4323/3, Ansari Road, Darya Ganj</p>
                    <p>New Delhi, India - 110002</p>
                    <p>Ph: +91 11 23250105,23250106</p>
                    <p>F: +91 11 23250141</p>
                    <span>Email :<a style = {{fontSize:'14px'}} href="mailto:mail@vkpublications.com">
                      {" "}
                      mail@vkpublications.com
                    </a></span>
                  </div>
                </Col>
              </Row>
              <OfficeAddress heading={this.state.address} />
          </div>
          </Container>
          <Footer />

        </div>
        
      </div>
    );
  }
}

export default Contact;
